import { create } from "zustand"

/** Whether a bulk selection pill is on screen, which the Ask bar makes way for. */
export const useSelectionPillState = create<{ visible: boolean }>()(() => ({
	visible: false,
}))
